class QuickBuy extends HTMLElement {
  constructor() {
    super()

    this.button = this.querySelector('[data-quick-buy-btn]')
    this.buttonText = this.querySelector('[data-quick-buy-btn] span')
    this.buttonLoader = this.querySelector('.loading-overlay__spinner')
    this.cartItems = document.querySelector('fostr-cart-drawer')
    this.fostrVariantRadios = this.querySelector('fostr-variant-radios')
    this.variantIds = this.getAttribute('variant-ids')
    this.properties = this.getAttribute('line-item-props')
    this.error = this.querySelector('.product-quickbuy__error-message-wrapper')
    this.errorMessageText = this.querySelector(
      '.product-quickbuy__error-message'
    )
    this.allowedValues = ['color', 'colour']
    this.colourName = this.querySelector(
      '.product-connections .form__label span'
    )
    this.colourGroup = this.querySelector('other-colours')
    this.gridCollection = document.getElementById('ProductGridContainer')
    this.sectionsToRender = []
    this.isGift = this.dataset.isGift

    this.swatchHiddenClass = 'hidden-mobile'
    this.plusMoreShowClass = ``

    if (this.fostrVariantRadios) {
      this.plusMoreShowClass = `[data-target="quickbuyitem-${this.fostrVariantRadios.dataset.section}"] .colour-swatch .plus-more.show-mobile`

      if (window.innerWidth > 749) {
        this.swatchHiddenClass = 'hidden-desktop'
        this.plusMoreShowClass = `[data-target="quickbuyitem-${this.fostrVariantRadios.dataset.section}"] .colour-swatch .plus-more.show-desktop`
      }

      this.shadeTrigger = document.querySelector(
        `[data-trigger="quickbuyitem-${this.fostrVariantRadios.dataset.section}"]`
      )

      this.shadeTarget = document.querySelectorAll(
        `[data-target="quickbuyitem-${this.fostrVariantRadios.dataset.section}"] .colour-swatch .colour.flex-rows`
      )

      this.shadeTargetPlus = document.querySelector(this.plusMoreShowClass)

      this.mobileATC = document.querySelector(
        `[data-trigger="quickbuyatc-${this.fostrVariantRadios.dataset.section}"]`
      )
    }

    if (!this.button) {
      return
    }

    this.button.addEventListener('click', this.onClickHandler.bind(this))
    this.addEventListener('change', this.onVariantChange.bind(this))

    if (this.shadeTrigger) {
      this.shadeTrigger.addEventListener(
        'click',
        this.onClickHandlershadeTrigger.bind(this)
      )
      this.shadeTargetPlus?.addEventListener(
        'click',
        this.onClickHandlershadeTrigger.bind(this)
      )
    }

    if (this.colourGroup) {
      const colourGroupItems = Array.from(
        this.colourGroup.querySelectorAll('a.colour')
      )
      colourGroupItems.forEach(colour => {
        colour.addEventListener(
          'click',
          this.onClickHandlerGroupColor.bind(this)
        )
      })
    }
  }

  onClickHandlershadeTrigger() {
    if (this.shadeTarget) {
      const shadeTargetItems = Array.from(this.shadeTarget)
      shadeTargetItems.forEach(shadeTargetItem => {
        shadeTargetItem.classList.remove(this.swatchHiddenClass)
      })
    }
    if (this.mobileATC) this.mobileATC.classList.remove('hidden')
    if (this.shadeTrigger) this.shadeTrigger.classList.add('hidden')
    if (this.shadeTargetPlus) this.shadeTargetPlus.classList.add('hidden')
    this.button.addEventListener('click', this.onClickHandler.bind(this))
  }

  onVariantChange() {
    this.classList.add('loading')
    this.querySelector('.loading-overlay.product-loading').classList.remove(
      'hidden'
    )

    this.updateOptions()
    this.updateMasterId()
    this.handleErrorMessage()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateVariantInput()
      this.updateMedia()
      this.renderProductInfo()
    }
  }

  onProductChange() {
    this.updateOptions()
    this.updateMasterId()
    this.handleErrorMessage()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateVariantInput()
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut
      )
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.fostrVariantRadios.querySelectorAll('fieldset')
    )
    this.options = fieldsets.map(fieldset => {
      let colourElement = Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked
      )
      if (
        this.allowedValues.includes(
          colourElement.name.split('-').reverse()[0].toLowerCase()
        )
      ) {
        this.colourName.innerHTML = colourElement.value
      }
      return Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked
      ).value
    })
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateVariantInput() {
    this.setAttribute('variant-ids', this.currentVariant.id)
    this.variantIds = this.getAttribute('variant-ids')
  }

  getVariantData() {
    this.variantData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    )
    return this.variantData
  }

  updateMedia(productImage = false) {
    let currentFeature = ''

    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) {
      if (productImage) {
        currentFeature = productImage
      } else {
        return
      }
    } else {
      currentFeature = this.currentVariant.featured_media.preview_image.src
    }

    const imgSizes = ['165', '360', '533', '720', '940', '1066']
    const format = '.' + currentFeature.split('.').reverse()[0]
    const itemMedia = document.querySelector(
      `.product-${this.fostrVariantRadios.dataset.section} [data-media-id="${this.fostrVariantRadios.dataset.section}"]`
    )

    let srcSizes = ''
    let newFormat = '_' + imgSizes[2] + 'x' + format
    let srcImg = currentFeature.replace(format, newFormat)

    imgSizes.forEach(function (size) {
      let newFormat = '_' + size + 'x' + format + ' ' + size + 'w,'
      let newSize = currentFeature.replace(format, newFormat)
      srcSizes = srcSizes + newSize
    })

    itemMedia.src = srcImg
    itemMedia.srcset = srcSizes
  }

  updateMediaSecond(productImage = false) {
    let currentFeature = ''

    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) {
      if (productImage) {
        currentFeature = productImage
      } else {
        return
      }
    } else {
      currentFeature = this.currentVariant.featured_media.preview_image.src
    }

    const imgSizes = ['165', '360', '533', '720', '940', '1066']
    const format = '.' + currentFeature.split('.').reverse()[0]
    const itemMedia = document.querySelector(
      `.product-${this.fostrVariantRadios.dataset.section} [data-media-second-id="${this.fostrVariantRadios.dataset.section}"]`
    )

    if (!itemMedia) return

    let srcSizes = ''
    let newFormat = '_' + imgSizes[2] + 'x' + format
    let srcImg = currentFeature.replace(format, newFormat)

    imgSizes.forEach(function (size) {
      let newFormat = '_' + size + 'x' + format + ' ' + size + 'w,'
      let newSize = currentFeature.replace(format, newFormat)
      srcSizes = srcSizes + newSize
    })

    itemMedia.src = srcImg
    itemMedia.srcset = srcSizes
  }

  renderProductInfo() {
    fetch(
      `${this.fostrVariantRadios.dataset.url}?variant=${this.currentVariant.id}`
    )
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const price_id = `.product-${this.fostrVariantRadios.dataset.section} .product-price`
        const price_source = html.querySelector(
          '.product .price .price__container'
        )
        const variantTitle_id = `.product-${this.fostrVariantRadios.dataset.section} .product-variant`
        const variantTitle_source = this.currentVariant.title

        document.querySelectorAll(price_id).forEach(price_destination => {
          if (price_source && price_destination) {
            price_destination.innerHTML = price_source.innerHTML
          }
        })

        document
          .querySelectorAll(variantTitle_id)
          .forEach(variantTitle_destination => {
            if (
              variantTitle_source &&
              variantTitle_destination &&
              variantTitle_source != 'Default Title'
            ) {
              variantTitle_destination.innerHTML = variantTitle_source
            }
          })

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
      .finally(() => {
        this.querySelector('.loading-overlay.product-loading').classList.add(
          'hidden'
        )
        this.classList.remove('loading')
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = this.button
    const addButtonText = this.buttonText

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('aria-disabled', true)
      this.querySelector('.loading-overlay.product-loading').classList.add(
        'hidden'
      )
      this.classList.remove('loading')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('aria-disabled')
      addButtonText.textContent = window.variantStrings.addToCart
    }
  }
  setUnavailable() {
    const addButton = this.button
    const addButtonText = this.buttonText
    const price = document.querySelector(
      `price-${this.fostrVariantRadios.dataset.section}`
    )
    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('visibility-hidden')
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.error
    this.errorMessage = this.errorMessage || this.errorMessageText
    if (this.errorMessageWrapper) {
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)
    }

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage
    }
  }

  getSectionsToRender() {
    return this.sectionsToRender
  }

  onClickHandler(event) {
    event.preventDefault()

    this.sectionsToRender = [
      {
        id: 'fostr-cart-drawer',
        selector: '.fostr-cart-wrapper'
      },
      {
        id: 'fostr-cart-icon-bubble'
      }
    ]

    this.variantIds = this.getAttribute('variant-ids')

    if (!this.variantIds) {
      return
    }

    this.handleErrorMessage()

    this.button.setAttribute('aria-disabled', true)
    this.button.classList.add('loading')

    const quantityEl = this.querySelector('input[name="quantity"]')
    const quantity = quantityEl ? parseInt(quantityEl.value) : 1

    let properties

    this.properties = this.getAttribute('line-item-props')

    if (this.properties) {
      try {
        properties = JSON.parse(this.properties)
        properties._bundle =
          properties._bundle +
          '-' +
          Math.floor(Math.random() * 1000000 + 1000) +
          ''
        console.log(properties)
      } catch (err) {
        console.error(err)
      }
    }

    let itemsObj = []
    const varIdsArr = this.variantIds.split(',')

    varIdsArr.forEach(varId => {
      itemsObj.push({
        id: varId,
        quantity: quantity,
        properties: properties
      })
    })

    let body = {
      items: itemsObj
    }

    if (this.cartItems) {
      body.sections = this.cartItems
        .getSectionsToRender()
        .map(section => section.id)
      body.sections_url = window.location.pathname
    }

    if (this.isGift === 'true') {
      if (!body.items[0].properties) body.items[0].properties = {}
      body.items[0].properties._free_gift = 'true'
      body.items[0].properties._gwpType = 'collection'
      body.items[0].properties._giftId = 'collectiongift'
    }

    body = JSON.stringify(body)

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.dispatchEvent(
            new CustomEvent('fostr-quick-buy-done', {
              bubbles: true,
              detail: { status: 'error', info: response }
            })
          )
          this.handleErrorMessage(response.description)
          return
        }

        this.dispatchEvent(
          new CustomEvent('fostr-quick-buy-done', {
            bubbles: true,
            detail: { status: 'success' }
          })
        )
        this.cartItems.renderContents(response)
        document.querySelector('fostr-cart-drawer').classList.remove('is-empty')
      })
      .catch(error => {
        this.dispatchEvent(
          new CustomEvent('fostr-quick-buy-done', {
            bubbles: true,
            detail: { status: 'error', error: error }
          })
        )
        console.error(error)
      })
      .finally(() => {
        this.button.classList.remove('loading')
        this.button.removeAttribute('aria-disabled')
        this.onClickHandlershadeTrigger()
      })
  }

  groupProductSetup(event) {
    event.preventDefault()

    this.classList.add('loading')
    this.querySelector('.loading-overlay.product-loading').classList.remove(
      'hidden'
    )
    let currentItem = this.colourGroup.querySelector('a.colour.current')
    let newItem = event.target
    let newItemUrl = event.target.href

    currentItem?.classList.remove('current')
    newItem.classList.add('current')

    this.newDataUrl = this.fostrVariantRadios.getAttribute('data-url')

    if (newItemUrl.includes(this.newDataUrl)) {
      this.querySelector('.loading-overlay.product-loading').classList.add(
        'hidden'
      )
      this.classList.remove('loading')
      return
    }
  }

  groupProductSetTitle(html, event) {
    const titleParent = `.product-${this.fostrVariantRadios.dataset.section} .product-title`
    const title = `.product-${this.fostrVariantRadios.dataset.section} .product-title .product-title--simple`
    const titleSource = html.querySelector('.product__title')
    document.querySelectorAll(titleParent).forEach(titleDestination => {
      if (titleSource && titleDestination) {
        document.querySelector(title).innerHTML = titleSource.innerHTML
        titleDestination.setAttribute('href', event.target.href)
      }
    })
  }

  groupProductSetVariantTitle(html, event) {
    const variantTitle_id = `.product-${this.fostrVariantRadios.dataset.section} .product-variant`
    const variantTitle_source = this.currentVariant.title
    document
      .querySelectorAll(variantTitle_id)
      .forEach(variantTitle_destination => {
        if (
          variantTitle_source &&
          variantTitle_destination &&
          variantTitle_source != 'Default Title'
        ) {
          variantTitle_destination.innerHTML = variantTitle_source
        }
      })
  }

  groupProductSetPrice(html) {
    const price = `.product-${this.fostrVariantRadios.dataset.section} .product-price`
    const priceSource = html.querySelector('.price')
    document.querySelectorAll(price).forEach(priceDestination => {
      if (priceSource && priceDestination) {
        priceDestination.innerHTML = priceSource.innerHTML
        priceDestination.classList.remove('visibility-hidden')
      }
    })
  }

  groupProductSetColour(html) {
    const colour = `.product-${this.fostrVariantRadios.dataset.section} .product-colour`
    const colourSource = html.querySelector('.colour_label')
    document.querySelectorAll(colour).forEach(colourDestination => {
      if (colourSource && colourDestination)
        colourDestination.innerHTML = colourSource.innerHTML
    })
  }

  groupProductSetVariantData(html, event) {
    const variantIDSource = html.querySelector(
      '.product-form input[type="hidden"][name="id"]'
    )
    this.fostrVariantRadios.setAttribute('data-url', event.target.href)
    if (variantIDSource) {
      this.setAttribute('variant-ids', variantIDSource.getAttribute('value'))
      this.variantIds = this.getAttribute('variant-ids')
    }
  }

  groupProductSetOptions(html) {
    const variantOptionsDestination = this.fostrVariantRadios
    const variantOptionsSource = html.querySelector('fostr-variant-radios')
    if (variantOptionsSource && variantOptionsDestination) {
      variantOptionsDestination.innerHTML = variantOptionsSource.innerHTML
    }
  }

  groupProductSetMedia(html) {
    this.mediaData = JSON.parse(
      html.querySelector('#product-image-data[type="application/json"]')
        .textContent
    )

    if (this.mediaData[0]) {
      this.updateMedia(this.mediaData[0].src)
    }

    if (this.mediaData[1]) {
      this.updateMediaSecond(this.mediaData[1].src)
    }
  }

  groupProductSetTags(html) {
    const tag = `.product-${this.fostrVariantRadios.dataset.section} .card__badges`
    const tagsSource = html.querySelector('.product-main-section .card__badges')

    document.querySelectorAll(tag).forEach(tagDestination => {
      if (tagsSource && tagDestination)
        tagDestination.innerHTML = tagsSource.innerHTML
    })
  }

  groupProductAdditionalDetail(html) {
    const detail = `.product-${this.fostrVariantRadios.dataset.section} .product-additional-detail .desc`
    const detailSource = html.querySelector(
      '.product-main-section .product__text.marketing-desc'
    )

    const detailBundle = `.product-${this.fostrVariantRadios.dataset.section} .product-additional-detail.bundle-additional-detail`
    const detailBundleSource = html.querySelector(
      '.product-main-section .product__text.marketing-desc'
    )

    if (document.querySelectorAll(detailBundle).length > 0) {
      document.querySelectorAll(detailBundle).forEach(detailDestination => {
        if (detailBundleSource && detailDestination)
          detailDestination.innerHTML = detailBundleSource.innerHTML
      })
    } else {
      document.querySelectorAll(detail).forEach(detailDestination => {
        if (detailSource && detailDestination)
          detailDestination.innerHTML = detailSource.innerHTML
      })
      var api = new Yotpo.API(yotpo)
      if (api) {
        api.refreshWidgets()
      }
    }
  }

  onClickHandlerGroupColor(event) {
    this.groupProductSetup(event)
    fetch(`${event.target.href}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        this.groupProductSetTitle(html, event)
        this.groupProductSetPrice(html)
        this.groupProductSetColour(html)
        this.groupProductSetVariantData(html, event)
        this.groupProductSetOptions(html)
        this.onProductChange()
        this.groupProductSetMedia(html)
        this.groupProductSetVariantTitle(html)
        this.groupProductSetTags(html)
        this.groupProductAdditionalDetail(html)
      })
      .finally(() => {
        this.querySelector('.loading-overlay.product-loading').classList.add(
          'hidden'
        )
        this.classList.remove('loading')
        if (window.BundleSelector)
          window.BundleSelector.handleSwatchClick(this, 'add', event)
        // make sure expanded list is open and ATC button is visible
        this.shadeTrigger.click()
      })
  }
}

customElements.define('quick-buy', QuickBuy)

class QuickBuySelects extends QuickBuy {
  constructor() {
    super()
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      select => select.value
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return this.options[0].toString() === variant.id.toString()
    })
  }

  groupProductSetOptions(html) {
    const variantOptionsDestination = this.fostrVariantRadios.querySelector(
      '.product-form__input--dropdown'
    )
    const variantOptionsSource = html.querySelector('.quickbuy-dropdown-source')
    if (variantOptionsSource && variantOptionsDestination) {
      const variantOptionsSourceFormLabel =
        variantOptionsSource.querySelector('label.form__label')
      variantOptionsSourceFormLabel.classList.add('hidden')
      variantOptionsDestination.innerHTML = variantOptionsSource.innerHTML
    }
  }

  groupProductSetVariantData(html, event) {
    this.fostrVariantRadios.setAttribute('data-url', event.target.href)
    const variantIDSource = html.querySelector(
      '.product-form input[type="hidden"][name="id"]'
    )
    if (variantIDSource) {
      this.setAttribute('variant-ids', variantIDSource.getAttribute('value'))
      this.variantIds = this.getAttribute('variant-ids')
    }

    const variantJsonSource = html.querySelector(
      'fostr-variant-radios [type="application/json"]'
    )
    const variantJsonDestination = this.fostrVariantRadios.querySelector(
      '[type="application/json"]'
    )
    if (variantJsonSource && variantJsonDestination) {
      variantJsonDestination.textContent = variantJsonSource.textContent
    }
  }
}

customElements.define('quick-buy-selects', QuickBuySelects)
